import React, {useEffect, useState} from 'react';

import {CommentsEventLogger} from '../../../services/analytics/comments';
import Modal from '../../../website-ui/components/comments/modal/modal';
import {
  COMMENTS_MODAL_SEARCH_PARAM_VALUE,
  MODAL_SEARCH_PARAM_KEY} from '../../../website-ui/constants/url';
import {NetworkStatusProvider} from '../../../website-ui/contexts/network-status-provider';
import {useArticleModel} from '../../../website-ui/utils/shared/useArticleModel';
import {getArticleIdFromUrl} from '../../../website-ui/utils/url';
import CommentsModal from '../components/modal-comments/modal-comments';

import {CommentsModalErrorBoundary} from './comments-modal-errorboundary';

import styles from './article-thread-modal.module.css';

export const ArticleThreadModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [articleId, setArticleId] = useState('');
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search));
  const [closedByUser, setClosedByUser] = useState(false);
  const articleData = useArticleModel(window.history.state?.id || getArticleIdFromUrl(window.location.pathname));

  const handleCloseModal = () => {
    const url = new URL(window.location.href);

    url.searchParams.delete(MODAL_SEARCH_PARAM_KEY);
    setSearchParams(url.searchParams);
    if (!window.history.state?.id) {
      window.history.pushState(null, null, url);
    } else {
      window.history.back();
    }
    setClosedByUser(true);
  };

  const handleClickOutside = () => {
    CommentsEventLogger.clickOutsideModal(articleId);
    handleCloseModal();
  };

  const popStateHandler = () => {
    setSearchParams(new URLSearchParams(window.location.search));
  };

  useEffect(() => {
    window.addEventListener('popstate', popStateHandler);
    return () => window.removeEventListener('popstate', popStateHandler);
  }, []);

  useEffect(() => {
    const isOpenInUrl = searchParams.get(MODAL_SEARCH_PARAM_KEY) === COMMENTS_MODAL_SEARCH_PARAM_VALUE;

    if (isOpenInUrl && !articleData.isCommentsEnabled) {
      const url = new URL(window.location.href);

      url.searchParams.delete(MODAL_SEARCH_PARAM_KEY);
      setSearchParams(url.searchParams);

      window.history.replaceState(null, '', url);
      return;
    }
    if (isOpenInUrl) {
      setClosedByUser(false);
      setArticleId(window.history.state?.id || getArticleIdFromUrl(window.location.pathname));
      if (!window.history.state?.target && !window.history.state?.id) {
        CommentsEventLogger.goFromUrl(getArticleIdFromUrl(window.location.pathname));
      }
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [searchParams, closedByUser, articleData]);

  return (
    <CommentsModalErrorBoundary articleId={articleId}>
      <NetworkStatusProvider>
        <Modal
          onClickOutside={handleClickOutside}
          isShow={isOpen}
          className={styles.modal}
        >
          <CommentsModal
            onClose={handleCloseModal}
            articleId={articleId}
          />
        </Modal>
      </NetworkStatusProvider>
    </CommentsModalErrorBoundary>
  );
};
